import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Keyboard, Pressable, Text, View } from "react-native";
import { InputContainer } from "../input-container";
import { ModalNative } from "../modal/modal-native";
import { styledRN } from "../styled";
const OptionContainer = styledRN(Pressable, ({ $theme }) => ({
    backgroundColor: $theme.midground,
    padding: 10,
    borderRadius: 10,
}));
export const SelectNative = React.memo(function SelectNative(props) {
    const [showPicker, setShowPicker] = React.useState(false);
    const selectedOption = props.options.find(o => o.value === props.value);
    React.useEffect(() => {
        if (showPicker) {
            Keyboard.dismiss();
        }
    }, [showPicker]);
    return (_jsxs(_Fragment, { children: [_jsx(Pressable, { onPress: () => setShowPicker(true), children: props.customStaticElement ?? (_jsx(InputContainer, { children: _jsx(Text, { style: { color: "white", fontSize: 15, fontFamily: "hiyllo" }, children: selectedOption?.label ?? props.placeholder }) })) }), showPicker ? (_jsx(ModalNative, { onClose: () => setShowPicker(false), children: _jsx(View, { style: { display: 'flex', flexDirection: 'column', gap: 10 }, children: props.options.map(option => (_jsx(OptionContainer, { onPress: () => {
                            props.onChangeValue?.(option.value);
                            setShowPicker(false);
                        }, children: _jsx(Text, { style: { color: 'white' }, children: option.label }) }, option.value))) }) })) : null] }));
});
